import { render, staticRenderFns } from "./CreateRole.vue?vue&type=template&id=79fef0dc&scoped=true"
import script from "./CreateRole.vue?vue&type=script&lang=js"
export * from "./CreateRole.vue?vue&type=script&lang=js"
import style0 from "./CreateRole.vue?vue&type=style&index=0&id=79fef0dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79fef0dc",
  null
  
)

export default component.exports